import script from "./SimpleSecureImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleSecureImage.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleSecureImage.vue?vue&type=style&index=0&id=37f3aee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f3aee0"]])

export default __exports__